import React, { useState } from "react";
import {
  NXDelete,
  NXEditPen,
  NXEyes,
} from "../../../icons";
import { useDeleteConfirmation } from "../../common";
import useApi from "../../../api";
import { useDispatch } from "react-redux";
import { fetchShippingMethod } from "../../../redux/shippingMethodSlice";
import ShippingMethodView from "./ShippingMethodView";
import ShippingMethodForm from "./ShippingMethodForm";
import GenericSelectableTable from "../../selectableTable";
import { toast } from "react-toastify";

interface Props {
  data: any[];
}

function ShippingMethodTable({ data }: Props) {
  const {handleDelete} = useDeleteConfirmation()
  const api = useApi()
  const dispatch = useDispatch()

  const [edit, setEdit] = useState<any>(null)

  const [shippingMethodId, setShippingMethodId] = useState<any>(null)

  const getEligibleShippingMethods = () => {
    dispatch(fetchShippingMethod() as any)
  }

  const columns = [
    { header: "ID", key: "id"},
    { header: "Name", key: "name"},
    { header: "Carrier", key: "carrier"},
    { header: "Action", key: "", render: (item:any)=>(
      <div className="flex gap-1 items-center">
        <button onClick={() => setShippingMethodId(item.id)}>
          <NXEyes className="text-primary-400" />
        </button>
        <button
          className="p-1"
          onClick={() => {
            handleDelete(
              item.id,
              "Shipping Method",
              api.deleteShippingMethod,
              getEligibleShippingMethods
            );
          }}
        >
          <NXDelete className="text-red-600" />
        </button>
        <button className="p-1" onClick={(e: any) => setEdit(item)}>
          <NXEditPen />
        </button>
      </div>
    )},    
  ]


  

  return (
    <div className="mt-5">
      <GenericSelectableTable columns={columns} data={data}/>

      {shippingMethodId && <ShippingMethodView id={shippingMethodId} isOpen={shippingMethodId ? true : false} onClose={()=>setShippingMethodId(null)} /> }
      
      {edit && <ShippingMethodForm edit={edit} isOpen={edit ? true : false} onClose={()=>setEdit(null)}/>}

    </div>
  );
}

export default ShippingMethodTable;
